import { render } from "./g-ecommerce__top-bar.vue?vue&type=template&id=1df3435b&ts=true"
import script from "./g-ecommerce__top-bar.vue?vue&type=script&lang=tsx"
export * from "./g-ecommerce__top-bar.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__